<ng-container *ngIf="relationsLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_REL'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="relationsError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_REL'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="!relationsLoading && !relationsError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
				class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}" class="p-inputtext-sm" />
			</span>
		</div>
		<p-table 
			#dt 
			*ngIf="relations && relations.length > 0; else noRelations"
			id = "tab_rels"
			[globalFilterFields]="globalFilterFields" 
			[value]="relations"
			[totalRecords] = "relations.length"
			styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped" responsiveLayout="scroll" 
			[paginator]="true" 
			[rows]="getCurrentPageSize(0, relations.length) "
			[rowsPerPageOptions]="setPaginator(relations.length)" 
			(onPage) = "onRowsPerPageChange($event, 0, relations.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_RELS'] }}"
			[tableStyle]="{'min-width': '60rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === relations.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="Business_ID">
						{{ translateServ.dictionary['MAINT_CS_TIT_BUS_ID'] || 'Business ID' }}
						<p-sortIcon field="Business_ID"></p-sortIcon>
					</th>
					<th pSortableColumn="Supplier_Name">
						{{ translateServ.dictionary['MAINT_CS_TIT_NAME'] || 'Name' }}
						<p-sortIcon field="Supplier_Name"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="Notes">
						{{ translateServ.dictionary['MAINT_IN_TIT_NOTES'] || 'Notes' }}
						<p-sortIcon field="Notes"></p-sortIcon>
					</th>
					<th pSortableColumn="CustomerSupplierExpenseCode">
						{{ translateServ.dictionary['STEP_TAB_TIT_EXP'] || 'Expense Code' }}
						<p-sortIcon field="CustomerSupplierExpenseCode"></p-sortIcon>
					</th>
					<th pSortableColumn="Description">
						{{ translateServ.dictionary['STEP_TAB_TIT_EXP_DESC'] || 'Expense Text' }}
						<p-sortIcon field="Description"></p-sortIcon>
					</th>
					<th pSortableColumn="customer_supplier_num">
						{{ translateServ.dictionary['MAINT_IN_TIT_INNER_NUM'] || 'Inner Number' }}
						<p-sortIcon field="customer_supplier_num"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['MAINT_CS_FIELD_STATUS'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_IN_TIT_DATE_ENT'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_IN_TIT_DATE_LUPD'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-relationItem>
				<tr>
					<td class="wrap-cell">{{ relationItem.RecID }}</td>
					<td class="wrap-cell">{{ relationItem.Business_ID }}</td>
					<td class="wrap-cell">{{ relationItem.Supplier_Name }}</td>
					<td class="wrap-cell" [title]="relationItem.Descr">
						<span>
							{{ (relationItem.Descr?.length > 30) ? (relationItem.Descr | slice:0:30) + '...' :
							(relationItem.Descr || 'N/A') }}
						</span>
					</td>
					<td class="wrap-cell">{{ relationItem.Notes || 'N/A' }}</td>
					<td class="wrap-cell">{{ relationItem.CustomerSupplierExpenseCode || 'N/A' }}</td>
					<td class="wrap-cell"> {{relationItem.Description || 'N/A'}}</td>
					<td class="wrap-cell">{{ relationItem.customer_supplier_num || 'N/A' }}</td>
					<td>
						<p-tag [value]="relationItem.IsActive === 1 ? 'Active' : 'Inactive'"
							[severity]="getRelationSeverity(relationItem.IsActive)"
							(click)="toggleRelationStatus(relationItem, true)"></p-tag>
					</td>
					<td>
						<p-tag
							[value]="relationItem.IsApproved === 1 ? this.translateServ.dictionary['YES'] : this.translateServ.dictionary['NO']"
							[severity]="relationItem.IsApproved === 1 ? 'success' : 'danger'"
							(click)="toggleRelationStatus(relationItem, false)"></p-tag>
					</td>
					<td class="wrap-cell">{{ relationItem.DateEntered ? (relationItem.DateEntered | date:'mediumDate') :
						'N/A' }}</td>
					<td class="wrap-cell">{{ relationItem.DateUpdated ? (relationItem.DateUpdated | date:'mediumDate') :
						'N/A' }}</td>
					<td class="wrap-cell">{{ relationItem.DateIncorporation ? (relationItem.DateIncorporation |
						date:'mediumDate') : 'N/A' }}</td>
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editRelation(relationItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']"
								tooltipPosition="top"></button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(relationItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<ng-template #noRelations>
		<div class="text-center p-4">
			<i class="pi pi-share-alt text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_REL'] }}</p>
		</div>
	</ng-template>
</ng-container>